import { Flex } from '@skin-seoul/design-system';
import { Skeleton } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';

type VerticalProductCardSkeletonProps = ComponentProps<typeof Flex>;

const VerticalProductCardSkeleton = ({ ...props }: VerticalProductCardSkeletonProps) => {
  return (
    <Flex direction="column" gap={4} minWidth="0" {...props}>
      <Skeleton borderRadius="8px" height="202px" width="100%" minWidth="0" />
      <Flex direction="column" gap={2} width="100%" minWidth="0">
        <Flex direction="column" gap={1} width="100%" minWidth="0">
          <Skeleton borderRadius="4px" height="16px" width="120px" />
          <Skeleton borderRadius="4px" height="20px" width="100%" />
        </Flex>
        <Skeleton borderRadius="4px" height="20px" width="70%" />
        <Skeleton borderRadius="6px" height="28px" width="80px" />
      </Flex>
    </Flex>
  );
};

export default VerticalProductCardSkeleton;
